import axios from 'axios';

const basePath = '/controles-campos';

const findByEntidade = (idEntidade) => axios.get(`${basePath}/entidades/${idEntidade}`);
const save = (idEntidade, controleCampos) => axios.post(`${basePath}/entidades/${idEntidade}`, controleCampos);

export default {
  findByEntidade,
  save,
};
